// TermsAndConditions.js
import React from "react";

function TermsAndConditions() {
  return (
    <div className="content">
      <h1>Terms & Conditions</h1>
      <ol>
        <li>
          <strong>Acceptance</strong> <br /> By using dayê, you agree to these
          terms.
        </li>
        <li>
          <strong>Account Creation and Usage</strong>
          <ul>
            <li>An email address is required to create an account.</li>
            <li>
              dayê is an assistant that helps users learn languages. The content
              is generated using AI and includes grammar, vocabulary content,
              and interactive games.
            </li>
          </ul>
        </li>
        <li>
          <strong>Age Restriction</strong> <br /> Users must be at least 13
          years old to use dayê.
        </li>
        <li>
          <strong>User Rights</strong>
          <ul>
            <li>Users can modify or delete their accounts and data.</li>
          </ul>
        </li>
        <li>
          <strong>Limitation of Liability</strong> <br /> LoRên IT is not liable
          for any harm resulting from dayê usage. dayê does not replace
          professional advice or instruction.
        </li>
        <li>
          <strong>Termination</strong> <br /> LoRên IT reserves the right to
          terminate or suspend access to dayê for breaches of these terms.
        </li>
        <li>
          <strong>Updates to Terms</strong> <br /> These terms may be updated
          periodically. Significant changes will notify users automatically.
        </li>
        <li>
          <strong>Audio Submissions</strong>
          <ul>
            <li>
              By submitting audio recordings within the app, you agree that
              these recordings may be used by all users and by dayê to support
              Kurdish language learning. All audio submissions are handled
              anonymously; no personal information such as name, email, or
              username will be associated with your recordings for other users.
            </li>
          </ul>
        </li>
        <li>
          <strong>User Anonymity</strong> <br /> Your audio recordings are
          stored and shared without any identifiable information. dayê ensures
          that no personal data (including name, email address, or username) is
          linked to your audio submissions, maintaining complete anonymity for
          all users.
        </li>
        <li>
          <strong>Prohibited Content</strong> <br /> Submitting audio recordings
          that contain violent, harmful, offensive, or inappropriate content is
          strictly prohibited. This includes, but is not limited to, recordings
          that use vocabulary incorrectly with malicious intent or include
          explicit, hateful, or abusive language. Any violation of these content
          guidelines may result in the immediate termination of your account
          without prior notice.
        </li>
        <li>
          <strong>Enforcement</strong> <br /> LoRên IT reserves the right to
          monitor audio submissions and take necessary actions to enforce these
          terms. Users found violating the prohibited content guidelines will
          face account suspension or termination.
        </li>
        <li>
          <strong>Updates to Terms</strong> <br /> These terms may be updated
          periodically. Significant changes will notify users automatically.
        </li>
      </ol>
    </div>
  );
}

export default TermsAndConditions;
